import ShadeFinderQuiz from 'components/ShadeFinder/ShadeFinderQuiz';
import { withShadeFinderQuizProps } from 'viewModel/shadeFinder/withShadeFinderQuizProps';

const ConnectedShadeFinderQuiz = withShadeFinderQuizProps(ShadeFinderQuiz);

export default ConnectedShadeFinderQuiz;
